module.exports = __webpack_public_path__ + "assets/media/moreMenu-facebook.afdfa1b0.svg";